import React from "react";
import CommonFrom from "../../../../../Common/Components/Form";
import { useReportCreate } from "../../Hooks";

function Index({ isApp, reloadPage, setReloadPage }) {
  const { store, loading } = useReportCreate(isApp, reloadPage, setReloadPage);
  return (
      <CommonFrom
        shadowClass={isApp && "shadow-none mt-3 appInputBox"}
        form={input}
        loading={loading}        
        header={!isApp && "گزارش اشکال"}
        textbtn="لیست گزارش اشکالات"
        linkbtn="/user/Report/list"
        btnName="ارسال گزارش"
        submit={store}
        isApp={isApp}
      />
  );
}

export default Index;
export const input = [
  {
    label: "عنوان",
    size: "col-md-9",
    classNames: "mt-2",
    placeholder: "",
    name: "title",
    value: "",
  },
  {
    label: "نوع دستگاه",
    size: "col-md-3",
    classNames: "mt-2",
    placeholder: "",
    name: "platform",
    input: "select",
    options: [
      { id: "ios", name: "ios" },
      { id: "android", name: "اندروید" },
      { id: "site", name: "سایت" },
    ],
  },
  {
    label: "متن گزارش",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "message",
    value: "",
    input: "textarea",
  },

  {
    label: "فایل گزارش (اختیاری)",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "documents",
    input: "file",
    accept: "image/png, image/jpeg",
    noNeed: true,
  },
];
